import { TabBarProfile } from '@/features/profile-page/TabBarProfile/ui/TabBarProfile'
import './ui/TabBarProfile.scss'
export default TabBarProfile
